import { ApiRouteRequestError } from '~/utils/errors'

export function useErrorMessages(error: ApiRouteRequestError | null) {
  if (!error) {
    return undefined
  }

  const translatableErrorMessages: { [key in any]: any } = {
    // GLP
    REQUEST_INVALID_DATA_INVALID: {
      id: 'REQUEST_INVALID_DATA_INVALID',
      defaultMessage: 'Request data is invalid',
    },
    MEMBERSHIP_NOT_FOUND_CUSTOMER_NOT_FOUND: {
      id: 'MEMBERSHIP_NOT_FOUND_CUSTOMER_NOT_FOUND',
      defaultMessage: 'Customer Not Found',
    },
    REQUEST_UNAUTHORIZED_TOKEN_INVALID: {
      id: 'REQUEST_UNAUTHORIZED_TOKEN_INVALID',
      defaultMessage: 'Token validation failed',
    },
    REQUEST_UNAUTHORIZED_TOKEN_EXPIRED: {
      id: 'REQUEST_UNAUTHORIZED_TOKEN_EXPIRED',
      defaultMessage: 'Token expired',
    },
    REQUEST_UNAUTHORIZED_DATA_INVALID: {
      id: 'REQUEST_UNAUTHORIZED_DATA_INVALID',
      defaultMessage: 'Token data/scope validation failed',
    },
    REQUEST_UNAUTHORIZED_AUTHORIZATION_LEVEL_INSUFFICIENT: {
      id: 'REQUEST_UNAUTHORIZED_AUTHORIZATION_LEVEL_INSUFFICIENT',
      defaultMessage: 'Token authentication level validation failed',
    },
    DEVELOPER_INACTIVE: {
      id: 'DEVELOPER_INACTIVE',
      defaultMessage:
        'The provided API key is no longer active and access to this API is forbidden',
    },
    DEVELOPER_NOT_AUTHORIZED: {
      id: 'DEVELOPER_NOT_AUTHORIZED',
      defaultMessage: 'The provided API key does not provide access to this API',
    },
    USAGE_RATE_EXCEEDED: {
      id: 'USAGE_RATE_EXCEEDED',
      defaultMessage: 'The usage rate (calls per second) has been exceeded for the API Key.',
    },
    USAGE_RATE_LIMIT_EXCEEDED: {
      id: 'USAGE_RATE_LIMIT_EXCEEDED',
      defaultMessage: 'The usage rate limit (calls per day) has been exceeded for the API Key.',
    },
    SSL_REQUIRED: {
      id: 'SSL_REQUIRED',
      defaultMessage: 'This API must be accessed using SSL.',
    },
    RESOURCE_NOT_FOUND: {
      id: 'RESOURCE_NOT_FOUND',
      defaultMessage: 'Resource not found',
    },
    REQUEST_INVALID_METHOD_NOT_SUPPORTED: {
      id: 'REQUEST_INVALID_METHOD_NOT_SUPPORTED',
      defaultMessage: 'Http method is unsupported',
    },
    INTERNAL_SERVER_ERROR: {
      id: 'INTERNAL_SERVER_ERROR',
      defaultMessage: 'Any other technical failure',
    },
    SYSTEM_UNAVAILABLE: {
      id: 'SYSTEM_UNAVAILABLE',
      defaultMessage: 'When a system is not available',
    },
    FATAL_ERROR_MESSAGE: {
      id: 'FATAL_ERROR_MESSAGE',
      defaultMessage:
        'Fatal error has occurred, please refresh the application and contact support if error persists',
    },
    DEFAULT_MESSAGE: {
      id: 'DEFAULT_MESSAGE',
      defaultMessage: 'Something went wrong, please check the details and try again',
    },
  }

  if (!error.code) {
    return translatableErrorMessages.DEFAULT_MESSAGE.defaultMessage
  }

  if (error.kind) {
    if (!(`${error.code}_${error.kind}` in translatableErrorMessages)) {
      return translatableErrorMessages.DEFAULT_MESSAGE.defaultMessage
    }
    return translatableErrorMessages[`${error.code}_${error.kind}`].defaultMessage
  }

  return error.code in translatableErrorMessages
    ? translatableErrorMessages[error.code].defaultMessage
    : translatableErrorMessages.DEFAULT_MESSAGE.defaultMessage
}
